import React, { useState, useEffect, useContext } from 'react'
import SideBarLayout from '../layouts/SideBarLayout'
import SideBarLayout1 from '../layouts/SideBarLayout1'
import SideBarLayout2 from '../layouts/SideBarLayout2'
import Modal from '../components/Modal'
import { useLocation, useNavigate } from 'react-router-dom'
import HomeInput from '../components/formik/HomeInput'
import * as Yup from 'yup'
import { Formik } from 'formik'
import NavCard from '../components/NavCard'
import { faAdd, faClose, faDiagramProject, faMapLocationDot, faPlusSquare, faStickyNote, faUserGroup, faUserCircle, faBullseye, faHouseFloodWaterCircleArrowRight, faNoteSticky, faBookOpen, faPager, faBook, faMinimize, faMaximize, faTrash, faListCheck, faMinus, faSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SearchBar from '../components/SearchBar'
import SideNavItem from '../components/SideNavItem'
import AppContext from '../contexts/AppContext';
import instance from '../api/client'
import authService from '../authentication'
import Loader from '../components/loaders/Loader'
import { toast } from 'react-toastify'
import HomeSubmit from '../components/formik/HomeSubmit'
import IconButton from '../components/IconButton'
import ModelItem from '../components/ModelItem'
import AppInput from '../components/formik/AppInput'
import NormalInput from '../components/NormalInput'
import NormalTextArea from '../components/NormalTextArea'
import AppSubmit from '../components/formik/AppSubmit'
import NormalSubmit from '../components/NormalSubmit'
import SelectorInput from '../components/SelectorInput'
import CriteriaItem from '../components/CriteriaItem'

const validationSchema = Yup.object().shape({
  name: Yup.string().required().label("Schema name"),
});

export default function Models() {
  const location = useLocation()
  const { state } = location
  const [criterias, setCriterias] = useState([{
    criteria: '', description: '', factors: [{ name: '', description: '', score: null, minimize: false }], minimize: false
  }])
  const [minimize, setMinimize] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showCreationForm, setshowCreationForm] = useState(false)
  const [selectedModel, setSelectedModel] = useState()
  const [name, setName] = useState('')
  const [pModels, setPModels] = useState([]);
  const [editDisabled, setEditDisabled] = useState(false)
  const navigate = useNavigate();
  const { user, setNavHeaderText } = useContext(AppContext)

  useEffect(() => {
    setNavHeaderText('Models')
  }, [])

  useEffect(() => {
    getPrioritizationModels()
  }, [])

  const getPrioritizationModels = async () => {
    setLoading(true)
    try {
      const { data, status } = await instance.get(`/prioritize/get-all-schemas`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        setPModels(data);
        console.log(data);
        setLoading(false)
        return status
      } else {
        console.log(status);
        setLoading(false)
        return status
      }
    } catch (error) {
      setLoading(false)
      return error
    }
  }

  const onEdit = async () => {
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/prioritize/edit-schema`, { id: selectedModel.id, name: name, schema: criterias }, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        console.log('Editted:', data);
        toast.success("Schema editted", {
          position: toast.POSITION.TOP_CENTER
        });
        setCriterias([{
          criteria: '', description: '', factors: [{ name: '', description: '', score: null, minimize: false }], minimize: false
        }])
        setLoading(false)
      } else {
        toast.error("An error occured", {
          position: toast.POSITION.TOP_CENTER
        });
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const deleteSchema = async (schemaName) => {
    setLoading(true)
    try {
      const { data, status } = await instance.delete(`/prioritize/delete-schema/${schemaName}`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      console.log('Deleted:', data);
      toast.success("Schema Deleted", {
        position: toast.POSITION.TOP_CENTER
      });
      setCriterias([{
        criteria: '', description: '', factors: [{ name: '', description: '', score: null, minimize: false }], minimize: false
      }])
      setLoading(false)

    } catch (error) {
      toast.error(`${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
      setLoading(false)
    }
  }

  const onSubmit = async () => {
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/prioritize/save-new-schema`, { name: name, schema: criterias }, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        console.log('Saved:', data);
        toast.success("Schema saved", {
          position: toast.POSITION.TOP_CENTER
        });
        setCriterias([{
          criteria: '', description: '', factors: [{ name: '', description: '', score: null, minimize: false }], minimize: false
        }])
        setLoading(false)
      } else {
        toast.error("An error occured", {
          position: toast.POSITION.TOP_CENTER
        });
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const onModelClick = (model) => {
    setSelectedModel(model)
    setName(model.name)
    setCriterias(model.schema)
  }

  return (
    <SideBarLayout2 title={'Bowtie Diagrams'}>
      <div className="flex-1 bg-gray-100 shadow-lg mx-5 px-5 pt-5 rounded">
        <div className='grid grid-cols-6 gap-2'>
          <div className='col-span-4 p-10'>
            <div className='flex items-center justify-between'>
              {
                selectedModel &&
                <div onClick={() => {
                  setSelectedModel(null); setName(''); setCriterias([{
                    criteria: '', description: '', factors: [{ name: '', description: '', score: null, minimize: false }], minimize: false
                  }])
                }} className='h-8 w-8 flex cursor-pointer justify-center items-center rounded-lg border-2 border-gray-300 hover:text-white hover:bg-gray-700'>
                  <FontAwesomeIcon icon={faClose} size='1x' />
                </div>

              }
            </div>

            <div className='flex-col px-14 py-4 overflow-y-scroll bg-white border border-3 border-slate-300 h-[80vh] overflow-y-scroll'>
              <div className='font-semibold mt-8'>{selectedModel ? 'Edit' : 'New'} model</div>

              <NormalInput onChange={(e) => { setName(e.target.value) }} value={name} placeholder={'Model name'} type={'text'} />

              {
                selectedModel ?

                  selectedModel.schema.map((criteria, index) => (
                    <CriteriaItem criteria={criteria} setCriterias={setCriterias} index={index} criterias={criterias} />
                  ))
                  :
                  criterias.map((criteria, index) => (
                    <CriteriaItem criteria={criteria} setCriterias={setCriterias} index={index} criterias={criterias} />
                  ))
              }
              <IconButton onClick={() => {
                const c = [...criterias]
                c.push({
                  criteria: '', description: '', factors: [{ name: '', description: '', score: null }], minimize: false
                })
                setCriterias(c)
              }} boxClassName={'w-full justify-center rounded-t-none rounded-b-xl'} icon={faBullseye} title={'Add criteria'} />
              <NormalSubmit theme onClick={selectedModel ? onEdit : onSubmit} className={'w-full mt-auto'} text={selectedModel ? 'Update' : 'Submit'} />

            </div>
          </div>
          <div className='col-span-2 gap-6 flex flex-col mt-10 mx-2 h-[80vh] overflow-y-scroll'>
            <div className='p-4 border-b-2 border-slate-300 flex bg-white'>
              <p className='font-dmsans text-lg font-bold'>Prioritization Models</p>
            </div>
            {
              !loading ?
                pModels.map((pModel) => (
                  <ModelItem selectedModel={selectedModel} onDelete={deleteSchema} onClick={() => onModelClick(pModel)} model={pModel} />
                ))
                :
                <div style={{}} className='flex items-center justify-center'>
                  <div className=' flex-1 items-center bg-white justify-center h-[68vh] pt-20'>
                    <Loader animationName={'list'} width={'100%'} />
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
    </SideBarLayout2>
  )
}
